var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdErrorCore } from "../../constants/IdErrorCore";
import { IdStyles } from "../../less/IdStyles";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { selectRankingSearchNotFoundTextLoca } from "../../selectors/selectPlayerLevelInfo";
import { selectRankingNameSearchErrorExists, selectRankingSelectedLanguage, } from "../../selectors/selectRankInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { actionErrorResolveError } from "../errors/actionError";
import { ButtonHudNormal } from "../generic/common/ButtonHudNormal";
import { Icon } from "../generic/icon/Icon";
import { SearchInput } from "../generic/search-input/SearchInput";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { HOCRanking } from "./HOCRanking";
import { PlayerRankingCategory } from "./PlayerRankingCategory";
var RankingHeaderDOM = /** @class */ (function (_super) {
    __extends(RankingHeaderDOM, _super);
    function RankingHeaderDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.onSearchClick = function (searchText) {
            var onRankingRequest = _this.props.onRankingRequest;
            onRankingRequest(searchText, undefined);
        };
        _this.state = {
            searchBtnDisabled: true,
            searchText: "",
        };
        return _this;
    }
    RankingHeaderDOM.prototype.render = function () {
        var _a = this.props, onFilterMenuClick = _a.onFilterMenuClick, selectedFilterLanguage = _a.selectedFilterLanguage, isNameSearchNotFound = _a.isNameSearchNotFound, searchNotFoundTextLoca = _a.searchNotFoundTextLoca, activeTabIndex = _a.activeTabIndex, resolveNameSearchError = _a.resolveNameSearchError;
        var showLanguageFilter = activeTabIndex === PlayerRankingCategory.PlayerLevelRanking;
        var languagesBtn = showLanguageFilter ? (React.createElement(ButtonHudNormal, { onClick: onFilterMenuClick },
            React.createElement(Icon, { icon: selectedFilterLanguage.assetName, styleId: IdStyles.IconMedium }))) : (React.createElement("div", null));
        return (React.createElement("div", { className: "flex flex--spaced flex--aligned padding__small" },
            languagesBtn,
            React.createElement("div", { className: "flex flex--aligned" },
                isNameSearchNotFound && (React.createElement("div", { className: "h-padding__small" },
                    React.createElement(TextLoca, { id: searchNotFoundTextLoca, className: IdStyles.TextNegative }))),
                React.createElement(SearchInput, { onClick: this.onSearchClick, inputTextPlaceholderLoca: IdLoca.rankingMenu_nameRankSearch, onResolveSearchNotFound: resolveNameSearchError, isSearchNotFound: isNameSearchNotFound }))));
    };
    return RankingHeaderDOM;
}(React.Component));
var mapState = function (state) { return ({
    activeTabIndex: selectModalTabId(state, IdModal.PlayerRanking),
    isNameSearchNotFound: selectRankingNameSearchErrorExists(state),
    searchNotFoundTextLoca: selectRankingSearchNotFoundTextLoca(state),
    selectedFilterLanguage: selectRankingSelectedLanguage(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onFilterMenuClick: function () { return dispatch(actionModalOpen(IdModal.RankingLanguageFilter)); },
    resolveNameSearchError: function () { return dispatch(actionErrorResolveError(IdErrorCore.TextErrors)); },
}); };
export var RankingHeader = connect(mapState, mapDispatch)(HOCRanking(RankingHeaderDOM));



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/RankingHeader.tsx
// module id = 2745
// module chunks = 3